import { IStyle } from "./../../../Types/Style";
import { IClientPatch, IPatchSubstAction, PatchType } from "../../../components/course-author/helpers/patches";
import { createPatchBase } from "../../../components/course-author/helpers/patches/creators";
import { ICompleteOrganization } from "../../types/common";
import { FontSection } from "../actions";

export function modifyStyleTitlePatch(
  style: IStyle,
  userId: string,
  title: string
): IClientPatch<IPatchSubstAction<string>> {
  return {
    ...createPatchBase(userId, style.versionId + 1),
    patch: {
      action: {
        type: PatchType.subst,
        x: style.displayName,
        y: title,
      },
      position: "displayName",
    },
  };
}

export function modifyLogoPatch(
  style: IStyle,
  userId: string,
  mediaId: string | null
): IClientPatch<IPatchSubstAction<string | null>> {
  return {
    ...createPatchBase(userId, style.versionId + 1),
    patch: {
      action: {
        type: PatchType.subst,
        x: style.logoImageId,
        y: mediaId,
      },
      position: "logoImageId",
    },
  };
}

export function modifyLessCodePatch(
  style: IStyle,
  userId: string,
  lessCode: string
): IClientPatch<IPatchSubstAction<string>> {
  return {
    ...createPatchBase(userId, style.versionId + 1),
    patch: {
      action: {
        type: PatchType.subst,
        x: style.lessCode,
        y: lessCode,
      },
      position: "lessCode",
    },
  };
}

export function modifyFontSection(
  style: IStyle,
  userId: string,
  fontId: string | null,
  fontSection: FontSection
): IClientPatch<IPatchSubstAction<string | null>> {
  type StyleFontFamilies = "headerFontFamilyId" | "monospaceFontFamilyId" | "bodyFontFamilyId";
  const getPosition = (): StyleFontFamilies => {
    switch (fontSection) {
      case FontSection.HEADER:
        return "headerFontFamilyId";
      case FontSection.MONOSPACE:
        return "monospaceFontFamilyId";
      default:
        return "bodyFontFamilyId";
    }
  };
  const position = getPosition();
  return {
    ...createPatchBase(userId, style.versionId + 1),
    patch: {
      action: {
        type: PatchType.subst,
        x: style[position],
        y: fontId,
      },
      position,
    },
  };
}

export function applyThemeToOrganization(
  organization: ICompleteOrganization,
  userId: string,
  styleId: string | null
): IClientPatch<IPatchSubstAction<string | null>> {
  return {
    ...createPatchBase(userId, organization.versionId + 1),
    patch: {
      action: {
        type: PatchType.subst,
        x: organization.style,
        y: styleId,
      },
      position: "style",
    },
  };
}
